module.exports = __webpack_public_path__ + "img/image2.bcd28c9c.jpeg";